import { Box, BoxProps, Heading } from '@razorpay/blade/components';
import React from 'react';

export const StepHeader = ({
  title,
  subtitle,
  ...boxProps
}: React.PropsWithChildren<{ title: string; subtitle: string } & BoxProps>) => (
  <Box gap="spacing.2" display="flex" {...boxProps}>
    <Heading weight="semibold" size="medium" color="surface.text.gray.subtle">
      {title}
    </Heading>
    <Heading weight="regular" size="medium" color="surface.text.gray.muted">
      {subtitle}
    </Heading>
  </Box>
);
